import React, { FC, ReactNode } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Button, Modal } from 'src/components';
import scenarioImageSrc from './scenario-image.png';
import * as S from './styles';

const msgs = defineMessages({
  levelHeader: { id: 'migration_classic_onboarding_tootltip2_title' },
  levelDescription: { id: 'migration_classic_onboarding_tooltip2_description' },
  scenarioHeader: { id: 'migration_classic_onboarding_tootltip3_title' },
  scenarioDescription: { id: 'migration_classic_onboarding_tooltip3_description_web' },
  dictionaryHeader: { id: 'migration_classic_onboarding_tootltip4_title' },
  dictionaryDescription: { id: 'migration_classic_onboarding_tooltip4_description_mobile' },
  dictionaryDescription2: { id: 'migration_classic_onboarding_tooltip4_description' },
  ok: { id: 'onboarding_coreLoopUsersToProgress_pointsAndLevels_CTA' },
});

export type ClassicMigrationContentVariant =
  | 'classic-migration-levels'
  | 'classic-migration-scenarios'
  | 'classic-migration-dictionary';

export const ClassicMigrationOnboardingModal: FC<{
  isOpen: boolean;
  onClose: () => void;
  contentVariant: ClassicMigrationContentVariant;
  progressIndicator?: string;
}> = ({ isOpen, onClose, contentVariant, progressIndicator }) => {
  const intl = useIntl();

  return (
    <Modal isOpen={isOpen} handleClose={onClose}>
      <S.ModalContent>
        {contentVariant === 'classic-migration-levels' && (
          <>
            <S.ModalHeader>{intl.formatMessage(msgs.levelHeader)}</S.ModalHeader>
            <S.Description>{intl.formatMessage(msgs.levelDescription)}</S.Description>
          </>
        )}
        {contentVariant === 'classic-migration-scenarios' && (
          <>
            <S.ModalHeader>{intl.formatMessage(msgs.scenarioHeader)}</S.ModalHeader>
            <S.ScenarioCard>
              <S.ScenarioImage src={scenarioImageSrc} />
            </S.ScenarioCard>
            <S.Description>
              {intl.formatMessage(msgs.scenarioDescription, {
                bold: (...chunks: ReactNode[]) => <S.BoldText key="BoldText">{chunks}</S.BoldText>,
              })}
            </S.Description>
          </>
        )}
        {contentVariant === 'classic-migration-dictionary' && (
          <>
            <S.ModalIconBar>
              <S.ModalIcon name="book" $active />
              <S.ModalIcon name="fire" />
              <S.ProfileIcon name="profileIcon" />
            </S.ModalIconBar>
            <S.ModalHeader>{intl.formatMessage(msgs.dictionaryHeader)}</S.ModalHeader>
            <S.Description>{intl.formatMessage(msgs.dictionaryDescription)}</S.Description>
            <S.SecondaryDescription>
              {intl.formatMessage(msgs.dictionaryDescription2)}
            </S.SecondaryDescription>
          </>
        )}
        <S.ActionButton>
          <Button buttonSize="medium" buttonType="primary" wide onClick={onClose}>
            {intl.formatMessage(msgs.ok)}
          </Button>
        </S.ActionButton>
        {progressIndicator && <S.ProgressIndicator>{progressIndicator}</S.ProgressIndicator>}
      </S.ModalContent>
    </Modal>
  );
};
